import 'framework7/dist/css/framework7.ios.min.css';
import 'framework7/dist/css/framework7.ios.colors.min.css';
import 'framework7-icons/css/framework7-icons.css';

/* OR for Material Theme:
import 'framework7/dist/css/framework7.material.min.css'
import 'framework7/dist/css/framework7.material.colors.min.css'
*/

import './css/app.css';

import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './components/App';

window.renderApp = function() {
	ReactDOM.render(<App/>, document.getElementById('root'));
};



// WEBPACK FOOTER //
// ./src/index.js